import React, { Dispatch, SetStateAction, useState } from 'react';
import { DefaultBsComponent } from '../../types/module';
import { classNames } from '../../utils/style';

import { AccordionButton } from './AccordionButton';
import { AccordionContent } from './AccordionContent';
import { AccordionContext, AccordionContextType } from './AccordionContext';

const AccordionComponent = ({
  className,
  as: Component = 'div',
  children,
  defaultValue = false,
  index,
  question,
  answer,
  open: _open,
  setOpen: _setOpen,
  onClick,
  ...props
}: DefaultBsComponent &
  Omit<AccordionContextType, 'open' | 'setOpen'> & {
    defaultValue?: boolean;
    open?: boolean;
    setOpen?: Dispatch<SetStateAction<boolean>>;
  }) => {
  const [open, setOpen] = useState(defaultValue);

  return (
    <AccordionContext.Provider
      value={{
        open: _open !== undefined ? _open : open,
        setOpen: _setOpen !== undefined ? _setOpen : setOpen,
        onClick,
        index,
        question,
        answer,
      }}
    >
      <Component
        {...props}
        className={classNames('Accordion', open ? 'open' : 'close', className)}
      >
        {children}
      </Component>
    </AccordionContext.Provider>
  );
};

export const Accordion = Object.assign(AccordionComponent, {
  Content: AccordionContent,
  Button: AccordionButton,
});
